import { useState } from 'react'
import { BIOLOGY_CATEGORIES } from '@shared/types/categories'
import type { BiologyCategory } from '@shared/types'

interface KeywordInputProps {
  selectedCategory: BiologyCategory | null
  keyword: string
  onChange: (keyword: string) => void
}

export default function KeywordInput({ selectedCategory, keyword, onChange }: KeywordInputProps) {
  const [showSuggestions, setShowSuggestions] = useState(false)

  // 获取当前目录的关键词建议
  const suggestions = selectedCategory
    ? BIOLOGY_CATEGORIES.find(cat => cat.name === selectedCategory)?.keywords || []
    : []

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-900">
        输入关键词
      </label>
      <div className="relative">
        <input
          type="text"
          value={keyword}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          placeholder={selectedCategory ? '输入研究关键词...' : '请先选择目录'}
          disabled={!selectedCategory}
          className="input"
        />

        {showSuggestions && suggestions.length > 0 && keyword && (
          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
            {suggestions
              .filter(s => s.toLowerCase().includes(keyword.toLowerCase()))
              .slice(0, 10)
              .map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => {
                    onChange(suggestion)
                    setShowSuggestions(false)
                  }}
                  className="w-full px-4 py-2 text-left hover:bg-gray-100 transition-colors"
                >
                  {suggestion}
                </button>
              ))}
          </div>
        )}
      </div>

      {selectedCategory && (
        <div className="flex flex-wrap gap-2 mt-3">
          {suggestions.slice(0, 8).map((suggestion, index) => (
            <button
              key={index}
              onClick={() => onChange(suggestion)}
              className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 transition-colors"
            >
              {suggestion}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
